import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en';
import { frCA } from './fr-CA';

export const savedCartTranslations: TranslationResources = {
  en,
  fr_CA: frCA,
};

export const savedCartTranslationChunksConfig: TranslationChunksConfig = {
  savedCart: [
    'quoteCommon',
    'quoteSearchForm',
    'quoteResult',
    'actionBar',
    'quoteDetailHeader',
    'quoteItems',
    'quotePartialItems',
    'quoteReference',
    'addToQuoteMessage',
    'cartCommon',
    'cartSearchForm',
    'cartResult',
    'addToCartMessage',
  ],
};
